import api from "@/lib/api";

const BASE = "/analisis-financiero";

export function obtenerCatalogo() {
  return api.get(`${BASE}/catalogo`);
}

export function previsualizarArchivo({ file, clientId, hoja }) {
  const body = new FormData();
  body.append("file", file);
  if (clientId) body.append("client_id", clientId);
  if (hoja) body.append("hoja", hoja);
  return api.post(`${BASE}/preview`, body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function previsualizarManual({ clientId, texto, renglones }) {
  return api.post(`${BASE}/preview-manual`, {
    client_id: clientId || "",
    texto: texto || "",
    renglones: renglones || [],
  });
}

export function guardarEstado(payload) {
  return api.post(`${BASE}/estados`, payload);
}

export function obtenerAnalisis({ clientId, ejercicio, mes, giroScian }) {
  return api.get(`${BASE}/analisis`, {
    params: {
      client_id: clientId,
      ejercicio,
      mes,
      giro_scian: giroScian || "",
    },
  });
}

export function obtenerGiro(clientId) {
  return api.get(`${BASE}/giro/${clientId}`);
}

export function cuerpoGiro(giro) {
  const scian = giro?.giro_scian || "";
  return {
    giro_scian: scian,
    giro_descripcion: giro?.giro_descripcion || "",
    origen_giro: scian ? (giro?.origen_giro || "manual") : "manual",
    actividad_orden: giro?.actividad_orden ?? null,
    actividad_descripcion: giro?.actividad_descripcion || "",
    actividad_porcentaje: giro?.actividad_porcentaje ?? null,
  };
}

export function guardarGiro(clientId, payload) {
  return api.put(`${BASE}/giro/${clientId}`, cuerpoGiro(payload));
}

export function borrarMes({ clientId, ejercicio, mes }) {
  return api.delete(`${BASE}/estados`, {
    params: { client_id: clientId, ejercicio, mes },
  });
}

export function obtenerReferencias() {
  return api.get(`${BASE}/referencias`);
}

export function guardarReferencia(payload, refId) {
  if (refId) return api.put(`${BASE}/referencias/${encodeURIComponent(refId)}`, payload);
  return api.post(`${BASE}/referencias`, payload);
}

export function eliminarReferencia(refId) {
  return api.delete(`${BASE}/referencias/${encodeURIComponent(refId)}`);
}

export function obtenerAuditoriaReferencias() {
  return api.get(`${BASE}/referencias/auditoria`);
}

export function obtenerProyeccionConfig({ clientId, ejercicio }) {
  return api.get(`${BASE}/proyeccion-config`, {
    params: { client_id: clientId, ejercicio },
  });
}

export function guardarProyeccionConfig(payload) {
  return api.put(`${BASE}/proyeccion-config`, payload);
}

export function generarProyeccion(payload) {
  return api.post(`${BASE}/proyeccion/generar`, payload);
}

export function descargarProyeccion(formato, { clientId, ejercicio }) {
  return api.get(`${BASE}/proyeccion.${formato}`, {
    params: { client_id: clientId, ejercicio },
    responseType: "blob",
  });
}

export function listarEstados({ clientId, ejercicio }) {
  return api.get(`${BASE}/estados`, { params: { client_id: clientId, ejercicio } });
}

export function descargarPlantilla() {
  return api.get(`${BASE}/plantilla.xlsx`, { responseType: "blob" });
}
